enum ELayersView {
  EDITINGREDIENTSVIEW = 'EDITINGREDIENTS',
  SELECTINGREDIENTSVIEW = 'SELECTINGREDIENTS',
  SELECTSTOCKSVIEW = 'SELECTSTOCKS',
  LAYERDESIGNVIEW = 'LAYERDESIGN',
  HIGHPHVIEW = 'HIGHPH',
  EDITGROUPSVIEWEDIT = 'EDITGROUPSEDIT',
  EDITGROUPSVIEWADD = 'EDITGROUPSADD',
  SELECTHIGHPH = 'Select High pH Value',
  SELECTINGREDIENTVLAUE = 'Select Ingredient',
  EDITINGREDIENTSVIEWCUSTOM = 'EDITINGREDIENTSCUSTOM',
  SELECTINGREDIENTSVIEWCUSTOM = 'SELECTINGREDIENTSCUSTOM',
  SELECTSTOCKSVIEWCUSTOM = 'SELECTSTOCKSCUSTOM',
  EXCLUDEINGREDIENT = 'EXCLUDEINGREDIENT',
  SELECTEXCLUDEINGREDIENT = 'SELECTEXCLUDEINGREDIENT',
  UPDATEINGREDIENTSVIEW = 'UPDATEINGREDIENTS',
  SELECTSEEDS = 'SELECTSEEDS',
  EDITSEED = 'EDITSEED',
  SELECTSCREEN = 'SELECTSCREEN',
  EDITSCREEN = 'EDITSCREEN',
  SELECTPROTEIN = 'SELECTPROTEIN',
  EDITPROTEIN = 'EDITPROTEIN',
  PROTEINTREEPATH = 'PROTEINTREEPATH',
  SELECTFRAGMENTSCREEN = 'Select Fragment Screen',
  FRAGMENTTREEPATH = 'Fragment Screen Tree Path',
  EDITFRAGMENT = 'Edit Fragment Screen',
}

export enum ELayersDefaultInput {
  SELECTINGREDIENT = 'Select Ingredient',
  SELECTSTOCKS = 'Select Stock',
  SELECTHIGHPHSTOCK = 'Select High PH Stock',
  VENDORNA = '(vendor n/a)',
}

export enum EGridVaryAlong {
  NONE = 1,
  ROW = 2,
  COLUMN = 3,
  LINKEDLAYER = 4,
  WELLNUMBER = 5,
  CUSTOM = 6,
}

export enum ELayersDetails {
  PROTEIN = 'PROTEIN',
  FRAGMENT = 'FRAGMENT',
  SEED = 'SEED',
  SCREEN = 'SCREEN',
}

export default ELayersView;
